import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useModalData } from '../../../../components/modals/ModalsContext'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import ProjectSelect from '../../../../containers/projects/select/ProjectSelect'

const GeneralSection = () => {
  const { toTemplates } = useModalData()

  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%" wrapOn="sm">
        <FormItem label="Nome*" field="name" />
      </Col>

      {toTemplates && (
        <Col width="100%" wrapOn="sm">
          <FormItem label="Projeto*" field="templatesProject" Input={ProjectSelect} fromTemplates />
        </Col>
      )}
    </Grid>
  )
}

export default GeneralSection
